export default __webpack_public_path__ + "static/media/gym.75d795e8.jpg";